import { SOPORTE_PDV } from './../shared/soportePdv';

export function getSoporteByCodigoPostal(
  codigo: string
): { zona: string | null; email: string } {
  const zonas = Object.entries(SOPORTE_PDV);

  for (const [zona, data] of zonas) {
    if (data.codigos.includes(codigo)) {
      return { zona, email: data.email };
    }
  }

  // Valor por defecto si no encuentra coincidencia
  return {
    zona: null,
    email: 'soportepdv@soydesimyo.es'
  };
}
